"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserHomepage = void 0;
var UserHomepage;
(function (UserHomepage) {
    UserHomepage["Dashboard"] = "Dashboard";
    UserHomepage["Claims"] = "Claims";
    UserHomepage["Inventories"] = "Inventories";
    UserHomepage["Order"] = "Order";
    UserHomepage["Prescribe"] = "Prescribe";
    UserHomepage["Labels"] = "Labels";
    UserHomepage["Dispense"] = "Dispense";
    UserHomepage["Reports"] = "Reports";
    UserHomepage["Ledger"] = "Ledger";
    UserHomepage["Eob"] = "Eob";
    UserHomepage["AssetApprovals"] = "AssetApprovals";
    UserHomepage["Financials"] = "Financials";
    UserHomepage["PatientPayments"] = "PatientPayments"; // D-002.55
})(UserHomepage = exports.UserHomepage || (exports.UserHomepage = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/user.ts
// module id = 4158
// module chunks = 0